import React from 'react';

function Dashboard() {
  return (
    <div className='text-black'>
      <h2 className='text-2xl mb-4'>Dashboard</h2>
      <p>Dashboard content will be implemented here.</p>
    </div>
  );
}

export default Dashboard;
